import { FC, PropsWithChildren } from 'react'

import { css, styled } from 'styled-components'

import { error } from 'core/styles/tokens'

// This component should wrap any field with it corresponding label using <FormLabel />
export const FieldContainer = styled.div<{ direction: 'row' | 'column' }>`
  ${({ direction }) =>
    direction === 'column'
      ? css`
          display: flex;
          flex-direction: column;
          gap: 8px;
        `
      : css`
          display: grid;
          grid-template-columns: 144px 1fr;
          gap: 16px;
          align-items: center;
        `}
`

// This component should wrap any input-type component with its corresponding error/warning message
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

type FormErrorProps = PropsWithChildren<{
  error?: any
}>

export const FormError = ({ children, error }: FormErrorProps) => {
  const parsedError =
    typeof error === 'string'
      ? error
      : 'message' in error
      ? error.message
      : error.toString()

  return children ? (
    children
  ) : (
    <StyledErrorMessage>Submission Error: {parsedError}</StyledErrorMessage>
  )
}

type SubmitContainerProps = PropsWithChildren<{}>

export const SubmitContainer: FC<SubmitContainerProps> = ({ children }) => (
  <StyledSubmitContainer>{children}</StyledSubmitContainer>
)

const StyledSubmitContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`

export const StyledErrorMessage = styled.div`
  padding: 16px 0 0;
  color: ${error};
  font-size: 12px;
  font-weight: 500;
`
